export default __webpack_public_path__ + "static/media/bg.7a55261a.jpg";